import axios from 'axios';
import Sortable from 'sortablejs';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = {
    params: String,
    ghostClass: { type: String, default: 'sortable-ghost' },
    disabled: { type: Boolean, default: false },
  };

  connect() {
    this.sortable = new Sortable(this.element, {
      draggable: '[data-draggable="true"]',
      filter: '[data-draggable="false"]',
      disabled: this.disabledValue,
      animation: 100,
      swapThreshold: 1,
      ghostClass: this.ghostClassValue,
      onEnd: this.onEnd.bind(this),
    });
  }

  disconnect() {
    this.sortable?.destroy();
  }

  async onEnd({ oldIndex, newIndex, item }) {
    if (!didSort(oldIndex, newIndex)) return;

    const src = item.getAttribute('data-draggable-patch-src');
    if (!src) return;

    try {
      await this.updatePosition(src, newIndex);
      this.dispatch('sorted');
    } catch {
      this.dispatch('error');
    }
  }

  updatePosition(src, newIndex) {
    const [name, rest] = this.paramsValue.split('.');
    const formData = buildFormData(name, rest, newIndex + 1);
    return axios.patch(src, formData);
  }
}

function didSort(oldIndex, newIndex) {
  if (oldIndex === newIndex) return false;
  return true;
}

function buildFormData(paramName, nestedParamName, value) {
  const object = { [paramName]: value };
  if (nestedParamName) {
    object[paramName] = { [nestedParamName]: value };
  }
  return object;
}
